import { render, staticRenderFns } from "./GalleryBig2.vue?vue&type=template&id=67017e12&scoped=true&"
import script from "./GalleryBig2.vue?vue&type=script&lang=js&"
export * from "./GalleryBig2.vue?vue&type=script&lang=js&"
import style0 from "./GalleryBig2.vue?vue&type=style&index=0&id=67017e12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67017e12",
  null
  
)

export default component.exports